"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'branch.list.title': 'Settori Professionali',
    'branch.list.empty': 'Nessun settore trovato',
};
